import * as amplitude from "@amplitude/analytics-react-native"
import { DialogM } from "@common/components/alert/dialog/Dialog"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import React, { useContext } from "react"
import { Dimensions, View } from "react-native"
import { IconButton, ProgressBar } from "react-native-paper"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"

const ProgressStepperHeader = (props) => {
    // ** Component props
    const {
        navigation,
        currentStep,
        goToPreviousStep,
        exitHandler = () => {},
        countSteps,
        submitted,
        headerRightComponent,
        hideProgressBar,
        exitWarning,
        noPrevious,
        noGoBack,
        hideGoBack,
        track,
        previousRouteName = "menu",
        exitWarningMessage = "Tous tes progrès dans cette activité seront perdus.",
        noNavigation = false,
        flex = 1,
        noExit = false,
    } = props

    const insets = useSafeAreaInsets()

    const backPressed = () => {
        if (track) {
            amplitude.track("button.clicked:progress-stepper.exit")
        }

        if (noPrevious || currentStep <= 1) {
            if (!exitWarning) {
                exit()
            } else {
                DialogM.show({
                    text1: "Veux-tu vraiment quitter ?",
                    text2: exitWarningMessage,
                    buttonText1: "Quitter",
                    buttonColor1: theme.colors.error,
                    onPress: exit,
                    buttonText2: "Annuler",
                })
            }
        } else {
            goToPreviousStep()
        }
        return true
    }

    const exit = () => {
        exitHandler()
        if (noNavigation) return

        if (navigation.canGoBack()) {
            navigation.goBack()
        } else {
            navigation.replace(previousRouteName)
        }
    }
    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                width:
                    flex !== 1
                        ? Dimensions.get("window").width * flex
                        : !noExit
                        ? dimensions?.width
                        : null,
                marginVertical: noExit ? 20 : null * flex,
                paddingTop:
                    !props.isLive ? insets.top : 0,
            }}
        >
            {!noExit && (
                <IconButton
                    icon={
                        noPrevious
                            ? "times"
                            : currentStep > 1
                            ? "arrow-left"
                            : "times"
                    }
                    iconColor={theme.colors.primary}
                    containerColor={theme.colors.transparent}
                    size={32}
                    onPress={backPressed}
                    disabled={noGoBack || (hideGoBack && currentStep === 1)}
                    style={{ opacity: hideGoBack && currentStep === 1 ? 0 : 1 }}
                />
            )}

            {!hideProgressBar && (
                <View
                    style={{
                        width:
                            dimensions?.width * flex -
                            70 -
                            (headerRightComponent ? 60 : 0),
                        height: 16,
                        borderRadius: 15,
                    }}
                >
                    <ProgressBar
                        progress={
                            submitted
                                ? 1
                                : countSteps
                                ? currentStep / (countSteps + 1)
                                : 0
                        }
                        color={theme.colors.success}
                        style={{
                            width:
                                (flex !== 1
                                    ? Dimensions.get("window").width * flex
                                    : dimensions?.width * flex) -
                                70 -
                                (headerRightComponent ? 60 : 0),
                            height: 16,
                            borderRadius: 15,
                            backgroundColor: theme.colors.lightMore,
                        }}
                    />
                </View>
            )}
            {!!headerRightComponent && (
                <View
                    style={{
                        width: 60,
                        alignItems: "flex-end",
                    }}
                >
                    {headerRightComponent}
                </View>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        isLive: state.liveMode.isLiveModeEnabled,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProgressStepperHeader)
